"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureCheckoutPriceBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formatNumber = _interopRequireDefault(require("../../util/formatNumber"));
var _planHelper = require("../../util/planHelper");
var _calculateTaxValueForFreeOffer = _interopRequireDefault(require("../../util/calculateTaxValueForFreeOffer"));
var _store = require("../../redux/store");
var _offerSlice = require("../../redux/offerSlice");
var _orderSlice = require("../../redux/orderSlice");
var _ThankYouPageStyled = require("../ThankYouPage/ThankYouPageStyled");
var _CheckoutPriceBoxStyled = require("./CheckoutPriceBoxStyled");
var _jsxRuntime = require("react/jsx-runtime");
const CheckoutPriceBox = _ref => {
  let {
    isCheckout,
    onRedeemClick
  } = _ref;
  const {
    customerPriceInclTax
  } = (0, _store.useAppSelector)(_offerSlice.selectOnlyOffer);
  const {
    priceBreakdown: {
      offerPrice,
      discountAmount,
      taxValue,
      customerServiceFee,
      paymentMethodFee
    },
    discount: {
      applied: isCouponApplied,
      type: discountType,
      periods: discountedPeriods
    },
    taxRate,
    country,
    totalPrice: finalPrice,
    currency
  } = (0, _store.useAppSelector)(_orderSlice.selectOnlyOrder);
  const {
    trialAvailable
  } = (0, _store.useAppSelector)(_offerSlice.selectOnlyOffer);
  const currencySymbol = _planHelper.currencyFormat[currency];
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const isTrial = trialAvailable && discountType === 'trial';
  const getCouponNote = () => {
    // unlimited
    if (discountedPeriods === 999) {
      return false;
    }
    return t("coupon-note-applied", 'Promotional Pricing applied!');
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledPriceBoxWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.StyledPriceBox, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.StyledPriceWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledLabel, {
          children: t('checkout-price-box.price', 'Price')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.StyledOfferPrice, {
          children: ["".concat(currencySymbol).concat((0, _formatNumber.default)(offerPrice), " "), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: country === 'US' ? t('checkout-price-box.excl-tax', 'excl. Tax') : t('checkout-price-box.excl-vat', 'excl. VAT')
          })]
        })]
      }), isCouponApplied && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledPriceWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.CouponNoteOuterWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.CouponNoteInnerWrapper, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledLabel, {
              children: isTrial ? t('checkout-price-box.trial-discount', 'Trial Discount') : t('checkout-price-box.coupon-discount', 'Coupon Discount')
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.StyledOfferPrice, {
              children: ["- ", currencySymbol, (0, _formatNumber.default)(discountAmount)]
            })]
          }), discountType === 'coupon' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.CouponNoteStyled, {
            "data-testid": "coupon-notes",
            children: getCouponNote()
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.StyledPriceWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledLabel, {
          children: country === 'US' ? t('checkout-price-box.applicable-tax', 'Applicable Tax') : t('checkout-price-box.applicable-vat', 'Applicable VAT')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledOfferPrice, {
          children: !taxValue && isCouponApplied ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            style: {
              textDecoration: 'line-through'
            },
            children: [currencySymbol, ' ', (0, _calculateTaxValueForFreeOffer.default)(offerPrice, taxRate, customerPriceInclTax)]
          }) : "".concat(currencySymbol).concat((0, _formatNumber.default)(taxValue))
        })]
      }), customerServiceFee !== 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.StyledPriceWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledLabel, {
          children: t('checkout-price-box.service-fee', 'Service Fee')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledOfferPrice, {
          children: "".concat(currencySymbol).concat((0, _formatNumber.default)(customerServiceFee))
        })]
      }), paymentMethodFee !== 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.StyledPriceWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledLabel, {
          children: t('checkout-price-box.payment-method-fee', 'Payment Method Fee')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledOfferPrice, {
          children: "".concat(currencySymbol).concat((0, _formatNumber.default)(paymentMethodFee))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledPriceWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.StyledTotalWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledTotalLabel, {
            children: t('checkout-price-box.total', 'Today`s total')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPriceBoxStyled.StyledTotalOfferPrice, {
            children: "".concat(currencySymbol).concat((0, _formatNumber.default)(finalPrice))
          })]
        })
      }), isCheckout && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutPriceBoxStyled.StyledRedeemButton, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "Have a gift code?"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThankYouPageStyled.LinkStyled, {
          as: "button",
          onClick: onRedeemClick,
          children: "Redeem here"
        })]
      })]
    })
  });
};
exports.PureCheckoutPriceBox = CheckoutPriceBox;
CheckoutPriceBox.propTypes = {
  isCheckout: _propTypes.default.bool,
  onRedeemClick: _propTypes.default.func
};
CheckoutPriceBox.defaultProps = {
  onRedeemClick: () => null,
  isCheckout: false
};
var _default = exports.default = CheckoutPriceBox;